export default {
  zh: {
    subscribedSuccessfully: '订阅成功',
    reviewNotice: '订阅成功，请在3~5分钟后刷新查看账户最新信息。',
    queryNotice: '请查询相关账户是否已完成订阅，避免重复操作。',
    subscribedFailure: '订阅失败',
    price: '订阅价格',
    USD: 'USD$',
    CNY: '￥',
    deviceNum: '套餐设备数',
    devices: '台',
    sure: '确定',
    contactUs: '如遇支付问题请联系我们，邮箱地址'
  },
  en: {
    subscribedSuccessfully: 'Subscribed Successfully',
    reviewNotice: 'Subscribed successfully, please refresh the page and check the latest info in 3-5 minutes.',
    queryNotice: 'Subscribed failed, in order to avoid duplicate operation, please check whether your relevant account has been subscribed.',
    subscribedFailure: 'Subscribed Failure',
    price: 'Subscription Price',
    USD: 'USD$',
    CNY: '￥',
    deviceNum: 'Device Limit',
    devices: 'device |devices',
    sure: 'OK',
    contactUs: 'If you have payment problem, please contact customer service via',
  }
}



// WEBPACK FOOTER //
// ./src/components/subscription/subscribeResult/lang.js